import React from 'react';
import {
  format,
} from 'date-fns';
import toast from 'react-hot-toast';
import {
  InfoText,
  StatusInfoContainer,
  DateInfoText,
  RegisterActivityContainer,
  RegisterActivityTitle,
  RegisterActivityButton,
} from './styles';
import { UserVirtualRaceType, VirtualRaceType } from '../../types/VirtualRace';
import { Activity } from '../../store/Activities.store';
import VirtualRaceActivitySummary from '../../components/VirtualRaceActivitySummary';
import coreApi from '../../services/coreApi';
import LinkActivitiesModal from '../../components/LinkActivitiesModal';

interface Props {
  virtualRace: VirtualRaceType,
  userVirtualRace: UserVirtualRaceType,
  allActivities: Activity[],
  refresh: () => void,
  setUserVirtualRace: React.Dispatch<React.SetStateAction<UserVirtualRaceType | undefined>>,
}

export default function VirtualRaceProgress({
  virtualRace, userVirtualRace, allActivities, refresh, setUserVirtualRace,
}: Props) {
  const [linkModalVisible, setLinkModalVisible] = React.useState(false);

  const startDate = new Date(virtualRace.startDate);
  const endDate = new Date(virtualRace.endDate);

  const linkedActivities = React.useMemo(() => {
    if (!userVirtualRace.activity_ids || userVirtualRace.activity_ids.length === 0) {
      return [];
    }
    return allActivities.filter((activity) => userVirtualRace.activity_ids?.includes(activity.id));
  }, [userVirtualRace.activity_ids, allActivities]);

  const handleLinkActivities = async (selectedIds: number[]) => {
    try {
      const response = await coreApi.put(`user-virtual-race/${userVirtualRace._id}`, {
        activity_ids: selectedIds,
      });
      if (response.data) {
        setUserVirtualRace(response.data);
      }
      toast.success('Atividades vinculadas com sucesso!');
      refresh();
    } catch (error) {
      toast.error('Erro ao vincular atividades');
    }
  };

  return (
    <>
      <LinkActivitiesModal
        visible={linkModalVisible}
        close={() => setLinkModalVisible(false)}
        activities={allActivities}
        virtualRace={virtualRace}
        userVirtualRace={userVirtualRace}
        onConfirm={handleLinkActivities}
      />
      <StatusInfoContainer>
        <RegisterActivityContainer>
          <RegisterActivityTitle>Está valendo!</RegisterActivityTitle>
          <RegisterActivityButton onClick={() => setLinkModalVisible(true)}>
            {userVirtualRace.activity_ids && userVirtualRace.activity_ids.length > 0
              ? 'Alterar atividade vinculada'
              : 'Vincular atividade'}
          </RegisterActivityButton>
        </RegisterActivityContainer>
        {linkedActivities.length > 0 && (
          <VirtualRaceActivitySummary activities={linkedActivities} />
        )}
        <DateInfoText>PERÍODO DE REGISTRO DE ATIVIDADES</DateInfoText>
        <InfoText>
          {`De ${format(startDate, 'dd/MM')} a ${format(endDate, 'dd/MM')}`}
        </InfoText>
      </StatusInfoContainer>
    </>
  );
}
